import { Component, OnInit, Input } from '@angular/core';

import { AppComponent } from '../app.component';
import { ViewEncapsulation } from '@angular/core'

@Component({
  standalone: false,
  selector: 'pnl-none',
  templateUrl: './z-pnl-none.component.html',
  styleUrls: ['./z-pnl-none.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class pnlNone implements OnInit {

  @Input() aPanelData: any;

  constructor( public app: AppComponent ) { }

  ngOnInit() {
  }

}
